<template>
	<div class="app-container" :class="{ 'collapsed-sidebar': collapsedSidebarclient }">
		<div class="app-content"
			:class="{ 'rtl-layout': rtlLayout, 'box-layout': toggleBoxLayout, 'dark-mode': darkModeEvent, 'red': getThemeColor==='red', 'green': getThemeColor==='green', 'orange': getThemeColor==='orange', '': getThemeColor==='default' }">
			<div class="sidebar-wrapper">
				<app-sidebar-nav></app-sidebar-nav>
			</div><!-- Sidebar panel closed -->
			<div class="sidebarOverlay" @click="closeSidebar"></div>
			<div class="main-content">
				<app-headerclient></app-headerclient>
				<!-- header closed -->
				<div class="base-container">
					<div class="inner-container">
						<transition name="router-anim" enter-active-class="animated slideInUpTiny animation-duration-fast">
							<router-view></router-view>
						</transition>
					</div><!-- inner container closed -->
				</div><!-- base container closed -->
			</div><!-- Main Content closed -->
		</div>
	</div><!-- app container closed -->
</template>

<script>
	import Headerclient from '@/components/Header/Headerclient'
	import SideNavclient from '@/components/Sidebar/SideNavclient'
	import Customizer from '@/components/Customizer/Customizer'
	import { mapGetters } from "vuex";
	import { mapState } from 'vuex'

	export default {
		data() {
			return {
				window: {
					width: 0,
					height: 0
				}
			}
		},
		name: 'Fullclient',
		components: {
			appHeaderclient: Headerclient,
			appSidebarNav: SideNavclient,
			appCustomizer: Customizer
		},
		mounted() {
			this.toggleSidebar()
		},
		computed: {
			...mapGetters({
				rtlLayout: "settings/rtlLayout",
				customizer: "settings/customizer",
				boxLayout: "settings/boxLayout",
				darkMode: "settings/darkMode",
				themeColor: "settings/themeColor",
				collapsedSidebarclient: "settings/collapsedSidebarclient",
				accountselected: "auth/accountselected"
			}),
			// computed property to get the state of collapsed sidebar
			sidebarCollapse() {
				return this.collapsedSidebarclient;
			},
			// computed property to get the state of customizer
			customizerIn() {
				return this.customizer;
			},
			// computed property to get the state of box layout
			toggleBoxLayout() {
				return this.boxLayout;
			},
			// computed property to get the state of dark mode
			darkModeEvent() {
				return this.darkMode;
			},
			// computed property to get theme color
			getThemeColor() {
				return this.themeColor;
			}
		},
		beforeUpdate() {
			this.toggleSidebar();
		},
		methods: {
			closeSidebar() {
				document.querySelector('.app-container').classList.add('collapsed-sidebarclient');
				document.querySelector('.sidebarOverlay').classList.remove('active');
			},
			toggleSidebar() {
				var element = document.getElementsByClassName("app-container");
				if (window.innerWidth < 1265) {
					document.querySelector('.app-container').classList.add('collapsed-sidebarclient');
					document.querySelector('.sidebarOverlay').classList.remove('active');
				}
				else if (window.innerWidth < 1201) {
					document.querySelector('.app-content').classList.remove('box-layout');
				}
				else if (window.innerWidth > 1265) {
					if (document.querySelector('.sidebarOverlay')) {
                         
                  document.querySelector('.sidebarOverlay').style.display = 'block';
                        }
				}
				$(window).resize(function () {
					if (window.innerWidth < 1265) {
						document.querySelector('.app-container').classList.add('collapsed-sidebarclient');
					}
					else if (window.innerWidth < 1201) {
						document.querySelector('.app-content').classList.remove('box-layout');
					}
					else {
						if (document.querySelector('.sidebarOverlay')) {
                         
                  document.querySelector('.sidebarOverlay').style.display = 'block';
                        }
						document.querySelector('.app-container').classList.remove('collapsed-sidebarclient');
					}
				});
			}
		},
		/*watch: {
			accountselected(val) {
				console.log('d')
				//צריך להחליף את הפונקציה להרצת מודולים ולעדכון פרמטרים כללי
				this.$store.dispatch('type_projects');
				this.$store.dispatch('run_modouls');
			}
		},*/
	}
</script>